// src/lib/supabase.ts
import { createClient, SupabaseClient } from "@supabase/supabase-js";

function required(name: string): string {
  const v = import.meta.env[name as keyof ImportMetaEnv] as string | undefined;
  if (!v) throw new Error(`${name} is required (set in .env.local)`);
  return v;
}

export const supabaseAgency: SupabaseClient = createClient(
  required("VITE_SUPABASE_AGENCY_URL"),
  required("VITE_SUPABASE_AGENCY_ANON_KEY"),
  { auth: { persistSession: true, storageKey: "agency-auth" } },
);

export const supabaseKreel: SupabaseClient = createClient(
  required("VITE_SUPABASE_KREEL_URL"),
  required("VITE_SUPABASE_KREEL_ANON_KEY"),
  { auth: { persistSession: true, storageKey: "kreel-auth" } },
);
